import React, { useEffect, useState, lazy, Suspense } from "react";
import { useParams } from "react-router-dom";
import orderIcon from "../../assets/img/icons/orderIcon.png";
import ticketIcon from "../../assets/img/icons/TicketIcon.png";
import callIcon from "../../assets/img/icons/callIcon.png";
import lightIcon from "../../assets/img/icons/Lightning.png";
import useRewardDataStore from "modules/rewards_points/store";
import {
  useExpectationSettings,
  useFeedbackFormStore,
  useRecentComment,
  useTicketHistory,
} from "modules/dashboards/actionables/store";
import { filter } from "lodash";
import { useOrderDetailsStore } from "modules/order_details/store";
import { useMobileHomeTaskList } from "pages/store";

const CalendarComponent = lazy(() => import("pages/CalendarComponent"));
const TrackingComponent = lazy(() => import("./TrackingComponent"));
const UserCard = lazy(() => import("./CustomerDetail"));

export const DispositionComponent = ({ customer }) => {
  const { fetRewardsData, rewardsData } = useRewardDataStore();
  const { expectationData, fetchExpectationData } = useExpectationSettings();
  const { fetchTicketHistory, ticketData } = useTicketHistory();
  const { data, fetchRecentCommentData } = useRecentComment();
  const { orderData, fetchOrderData } = useOrderDetailsStore();
  const { segmentData, fetchAllSegmentData } = useMobileHomeTaskList();
  const { id } = useParams();

  const { fetchfeedbackFormFetchData } = useFeedbackFormStore();

  const [currentMonth, setCurrentMonth] = useState(new Date());
  const [show, setShow] = useState(true);
  const [dateNo, setDateNo] = useState(null);
  const [products, setProducts] = useState(null);
  const [defaultMonth] = useState(new Date().getMonth() + 1);
  const [defaultYear] = useState(new Date().getFullYear());
  const [order, setOrder] = useState(true);
  const [ticket, setTicket] = useState(true);
  const [reward, setReward] = useState(true);
  const [call, setCall] = useState(true);
  const [feedbackFormsData, setFeedbackFormsData] = useState({});
  const feedbackFormNames = [
    "activeCxO5plus",
    "dropped_leads",
    "d12FeedbackForm",
    "kitStarted",
  ];
  const fetchFeedbackForms = async () => {
    const fetchedData = {};
    for (let formName of feedbackFormNames) {
      try {
        const response = await fetchfeedbackFormFetchData(id, formName);
        fetchedData[formName] = response;
      } catch (error) {
        if (error.response?.status === 400) {
          fetchedData[formName] = null;
        } else {
          console.error(`Error fetching form ${formName}:`, error);
        }
      }
    }
    setFeedbackFormsData(fetchedData);
  };

  useEffect(() => {
    if (id && show) {
      fetRewardsData(id, defaultYear, defaultMonth);
      fetchExpectationData(id);
      fetchTicketHistory(id);
      fetchRecentCommentData(id);
      fetchOrderData(id);
      fetchAllSegmentData(id);
      fetchFeedbackForms();
    }
  }, [id, show, defaultYear, defaultMonth]);

  const filterResponses = (responses, searchTerm) => {
    return responses?.filter((item) =>
      Object.values(item).some(
        (value) => typeof value === "string" && value.includes(searchTerm)
      )
    );
  };

  const deliveredOrder = filter(
    customer.orders || [],
    (order) => order.status === "delivered"
  );

  const stage = filterResponses(customer?.responses, "Stage");
  const age = filterResponses(customer?.responses, "How old are you?");
  const language = filterResponses(customer?.responses, "language");
  const ticketCount =
    ticketData?.filter((item) => item?.status === "Open").length || 0;

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <Suspense fallback={<div>Loading...</div>}>
        <div className="d-flex flex-column gap-2">
          <div className="d-flex card user-card-container flex-row gap-3 h-100">
            <div className="w-50">
              <UserCard
                name={customer?.user?.first_name}
                age={age?.[0]?.response || "N/A"}
                gender={customer?.user?.gender === "M" ? "Male" : "Female"}
                stage={stage?.[0]?.response || "N/A"}
                language={language?.[0]?.response || "N/A"}
                expectation={expectationData?.monthsDetails?.months || "N/A"}
                totalOrders={orderData?.actualKitCountForUser || "N/A"}
                appUser={customer?.app_user ? "Yes" : "No"}
                communityUser={customer?.community || null}
                ticketStatus={ticketCount}
                points={rewardsData?.rewardBalance || 0}
                runningMonth={segmentData?.runningMonthForHairKit || 0}
                rewardsData={rewardsData}
              />
            </div>
            <div className="w-50 d-flex flex-row">
              <CalendarComponent
                currentMonth={currentMonth}
                rewardsActivityLogs={rewardsData?.activityLogs}
                setDateNo={setDateNo}
                dateNo={dateNo}
                products={products}
                setProducts={setProducts}
                leadPop={true}
                setCurrentMonth={setCurrentMonth}
              />
            </div>
          </div>
          <div className="card-footer">
            <button
              className={
                order
                  ? "text-white bg-primary orders button-pop"
                  : "button-pop orders"
              }
              onClick={() => setOrder(!order)}
            >
              <img
                src={orderIcon}
                alt="icon"
                className="bg-primary rounded-3"
              />{" "}
              Orders
            </button>
            <button
              className={
                call
                  ? "button-pop call-comments text-white bg-success"
                  : "button-pop call-comments"
              }
              onClick={() => setCall(!call)}
            >
              <img
                src={callIcon}
                alt="icon"
                className="bg-success rounded fs-2"
              />{" "}
              Call & comments
            </button>
            <button
              className={
                reward
                  ? "button-pop streaks text-white bg-warning"
                  : "button-pop streaks"
              }
              onClick={() => setReward(!reward)}
            >
              <img src={lightIcon} alt="icon" className="rounded fs-2" />{" "}
              Streaks
            </button>
            <button
              className={
                ticket
                  ? "button-pop tickets text-white bg-info"
                  : "button-pop tickets"
              }
              onClick={() => setTicket(!ticket)}
            >
              <img src={ticketIcon} alt="icon" className="rounded" /> Tickets
            </button>
          </div>
          <div className="clear mt-n4">
            <TrackingComponent
              customer={customer}
              ticketData={ticketData}
              recentComment={data}
              rewardsData={rewardsData?.rewardHistory}
              deliveredOrder={deliveredOrder}
              order={order}
              ticket={ticket}
              reward={reward}
              call={call}
              feedbackFormsData={feedbackFormsData}
            />
          </div>
        </div>
      </Suspense>
    </>
  );
};
